import { CardConfigTypes } from "./types/card-config-types";

export const CardConfig: CardConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
